const doc = [({"en":({"js":({"admin":({"highscore_generations":({"participants":({"schools_uni_c_id":"Schools UNI-C ID", "export_csv":"Export CSV"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;